import { NgOptimizedImage } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { Router, RouterLink } from "@angular/router";

import { SpotlightPlant } from "@models/SpotlightPlant";

import { SpotlightService } from "@services/spotlight.service";

import { PATHS } from "@shared/resources/paths.constants";

import { AppConfig } from "../app.config";
import { PlantsJumbotronComponent } from "../home/jumbotron/plants-jumbotron.component";

@Component({
  selector: "home",
  templateUrl: "home.component.html",
  styleUrls: ["home.component.scss"],
  imports: [NgOptimizedImage, RouterLink, PlantsJumbotronComponent]
})
export class HomeComponent implements OnInit {
  spotlightPlantImageUrl: string = AppConfig.settings.serviceUrls.imageLibraryUrl + "/thumbnail/";

  spotlightPlant: SpotlightPlant;
  errorMessage: string;
  imageUrl: string;
  commonName: string;
  scientificName: string;
  altImageText: string;
  nrcsPollinatorUrl: string;
  appConfig = inject(AppConfig);

  constructor(
    public router: Router,
    private spotlightService: SpotlightService
  ) {}

  ngOnInit(): void {
    this.getSpotlightPlant();
    this.nrcsPollinatorUrl = this.appConfig.getPlantsUrl() + PATHS.NRCS_POLLINATOR;
  }

  private getSpotlightPlant(): void {
    this.spotlightService.getSpotlightPlant().subscribe({
      next: (spotlightPlant) => (this.spotlightPlant = spotlightPlant),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      error: (error) => (this.errorMessage = <any>error),
      complete: () => this.loadSpotlightPlant()
    });
  }

  private loadSpotlightPlant(): void {
    this.imageUrl = this.spotlightPlantImageUrl + this.spotlightPlant.ImageFilename;
    this.commonName = this.spotlightPlant.CommonName;
    this.scientificName = this.spotlightPlant.ScientificName;
    this.altImageText = "thumbnail of" + this.spotlightPlant.CommonName;
  }

  routeToProfile(): void {
    this.router.navigate(["/plant-profile", this.spotlightPlant.PlantSymbol]);
  }
}
